import { createSlice } from "@reduxjs/toolkit";
import { CategoriaEmpresaModel } from "../../../models/categoriaEmpresa/categoriaEmpresaModel";
import { buscarCategoriaEmpresa } from "../../../services/categoriaEmpresaService";

export interface CategoriaEmpresaState {
  //buscar categoria empresa
  loading: boolean;
  list: CategoriaEmpresaModel[];
  entity: CategoriaEmpresaModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: CategoriaEmpresaState = {
  //buscar categoria empresa
  loading: false,
  list: [],
  entity: {} as CategoriaEmpresaModel,

  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const categoriaEmpresaSlice = createSlice({
  name: "categoriaEmpresa",
  initialState,
  reducers: {
    //buscar categoria empresa
    setEntityCategoriaEmpresa: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarCategoriaEmpresa: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarCategoriaEmpresa: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase("resetAll", () => initialState);

    //buscar categoria empresa
    builder.addCase(buscarCategoriaEmpresa.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarCategoriaEmpresa.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarCategoriaEmpresa.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar categoria empresa
  setEntityCategoriaEmpresa,
  //internal
  setModalCadastrarCategoriaEmpresa,
  setModalDeletarCategoriaEmpresa,
} = categoriaEmpresaSlice.actions;

export default categoriaEmpresaSlice.reducer;
